/**
 * API Endpoints to handle Custom pages.
 * Text are editable only by admins, therefore is trustable.
 */
import Axios, { type AxiosRequestConfig } from "axios";

type CustomPageType = {
  language: string;
  text: TrustedHTML;
};

const getCustomPage = async (url: string, language?: string, config?: AxiosRequestConfig) => {
  config = config || {};
  config.params = language ? { lang: language } : undefined;
  const response = await Axios.get<CustomPageType>(url, config);
  return response.data;
};

export const getPrivacyPolicy = async (language?: string, config?: AxiosRequestConfig) => {
  return await getCustomPage("/api/custom-pages/privacy-policy/", language, config);
};

export const getTermsAndConditions = async (language?: string, config?: AxiosRequestConfig) => {
  return await getCustomPage("/api/custom-pages/terms-and-conditions/", language, config);
};
